export function addShippingServiceSettings(shippingservicesettings) {
  return {
      type: 'ADD_CURRENT_SHIPPING_SERVICE_SETTINGS',
      shippingservicesettings,
  }
}
